import React, { useState } from 'react'
import { useForm, SubmitHandler } from "react-hook-form"
import { useAuth } from '../hooks/useAuth'
import useEndpoints from '../API/apiConfig'
import axios from 'axios'
export default function Login() {
  const { login } = useAuth()
  const endpoints = useEndpoints()
  const [invalid, setInvalid] = useState(false)
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
  } = useForm()

  async function onSubmit(data) {
    try {
      const response = await axios.post(endpoints.LOGIN_ADMIN, data);
      if (response) {
        login(response);
      }
    } catch (error) {
      console.error("Ошибка при выполнении запроса:", error);
      setInvalid(true);
    }
  }



  return (
    <section className='login'>
      <h1 className="login__title">Авторизация</h1>
      <form className="login__form" onSubmit={handleSubmit(onSubmit)}>
        <input onFocus={() => setInvalid(false)} className="login__input" type='text' {...register("adminLogin", { required: true })} />
        {errors.adminLogin && <span>Это поле обязательно</span>}
        <input onFocus={() => setInvalid(false)} className="login__input" type='password' {...register("adminPassword", { required: true })} />
        {errors.adminPassword && <span>Это поле обязательно</span>}
        {invalid && <span >Неверный логин или пароль</span>}
        <input className="login__button" type="submit" />
      </form>
    </section>
  )
}
